import { Map as map } from 'immutable';
const C = require("../constants");

function FindClientReducer(state = map(), action) {
    switch (action.type) {
        case C.FIND_CLIENT_MODAL:
            return action.data;
        default:
            return state;
    }
};

export default FindClientReducer;


// WEBPACK FOOTER //
// ./src/reducers/FindClientReducer.js